module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/orders/shop-b0cbf5973eadf6df399377d0cf0a0e1f.jpg";